// --------------------------------------------------------------
// Created On: 2025-10-29
// Author: Zachary Thomas
//
// Last Modified: 2025-11-04
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Attempt to load initial state from local storage.
let initialToken = null;
const localStorageToken = localStorage.getItem("reduxAccessToken");
if (localStorageToken !== "") {
  initialToken = localStorageToken;
}

const initialState: string | null = initialToken;

// A Redux slice for the access token that is passed to the backend.
const accessTokenSlice = createSlice({
  name: "accessToken",
  initialState,
  reducers: {
    setAccessToken: (state, action: PayloadAction<string | null>) => {
      localStorage.setItem("reduxAccessToken", action.payload ?? "");
      return action.payload;
    },
  },
});

export const { setAccessToken } = accessTokenSlice.actions;
export default accessTokenSlice.reducer;
